import { create } from 'zustand'

export const useCollectionsStore = create(set => ({
  feelsMuted: true,
  setFeelsMuted: () => set(state => ({ feelsMuted: !state.feelsMuted })),
}))